import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

export interface ICustomizationData {
    templates: [{
        id : string,
        name : string,
        version : number,
        isDefault : boolean
    }];
    liliLogos: [{
        id : string,
        name : string,
isDefault : boolean
}];
brandColors: [{
    color : string,
    name : string,
    isDefault : boolean
}];
}

interface IProps {
    customerId: string;
    onSuccess: (data: ICustomizationData) => void;
}

export const useInvoiceCustomizationQuery = ({ customerId, onSuccess }: IProps) => useQuery(
  'InvoiceCustomizationQuery',
  async () => {
    const { data } = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/invoice/customization`);
    return data;
  },
  {
    retry: 1,
    enabled: false,
    onSuccess: (data:ICustomizationData) => {
      onSuccess(data);
    },
  },
);
